// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const RefineFilters: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15">
            <path
                fill="currentColor"
                d="M15 11.5H7.788a2.496 2.496 0 0 0-4.575 0H1a1 1 0 0 0 0 2h2.21A2.5 2.5 0 0 0 5.5 15a2.498 2.498 0 0 0 2.29-1.5H15a1 1 0 0 0 0-2Zm-9.5 2c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.45 1-1 1Zm9.5-7h-2.21a2.496 2.496 0 0 0-4.577 0H1a1 1 0 1 0 0 2h7.213a2.496 2.496 0 0 0 4.576 0H15a1 1 0 0 0 0-2Zm-4.5 2c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.45 1-1 1ZM1 3.5h3.213a2.496 2.496 0 0 0 4.576 0H15a1 1 0 0 0 0-2H8.788a2.494 2.494 0 0 0-4.575 0H1a1 1 0 0 0 0 2Zm5.5-2c.551 0 1 .449 1 1 0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.45-1 1-1Z"
                opacity=".33"
            />
        </svg>
    );
};

export default React.memo(RefineFilters);
